module.exports = "/_next/static/images/video_id_7117371305002978606-85159bb353eee6fe750310c8b5577655.jpg";